import { Box, Button, MenuItem, Select } from '@mui/material';

interface ResultsPaginationProps {
  page: number;
  pageCount: number;
  pageSize: number;
  // page sizes run from one outcome per page up to all of them
  totalCount: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const PAGE_BUTTON_SX = {
  minWidth: '40px',
  fontSize: '13px',
};

function ResultsPagination({
  page,
  pageCount,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
}: ResultsPaginationProps) {
  const pageSizeOptions = Array.from({ length: Math.max(1, totalCount) }, (_, index) => index + 1);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Button
        variant='contained'
        disableElevation
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        sx={{ ...PAGE_BUTTON_SX, paddingX: '20px' }}
      >
        Previous
      </Button>
      {Array.from({ length: pageCount }, (_, index) => index + 1).map((pageNumber) => (
        <Button
          key={pageNumber}
          variant='outlined'
          aria-current={pageNumber === page ? 'page' : undefined}
          onClick={() => onPageChange(pageNumber)}
          sx={{
            ...PAGE_BUTTON_SX,
            borderColor: pageNumber === page ? '#132B50' : '#CBD5E0',
            backgroundColor: pageNumber === page ? '#DBEAFE' : '#fff',
            color: pageNumber === page ? '#1A365D' : '#4A5568',
            fontWeight: pageNumber === page ? 700 : 500,
          }}
        >
          {pageNumber}
        </Button>
      ))}
      <Select
        size='small'
        value={pageSize}
        inputProps={{ 'aria-label': 'Results per page' }}
        renderValue={(value) => `${value} / Result`}
        onChange={(event) => onPageSizeChange(Number(event.target.value))}
        sx={{ height: '36px', fontSize: '13px', fontWeight: 500, color: '#4A5568', backgroundColor: '#fff' }}
      >
        {pageSizeOptions.map((option) => (
          <MenuItem key={option} value={option} sx={{ fontSize: '13px' }}>
            {option} / Result
          </MenuItem>
        ))}
      </Select>
      <Button
        variant='contained'
        disableElevation
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
        sx={{ ...PAGE_BUTTON_SX, paddingX: '28px' }}
      >
        Next
      </Button>
    </Box>
  );
}

export default ResultsPagination;
